export const eventCategory = {
  APP_OPENED: 'app_opened',
  APP_CLOSED: 'app_closed',
  APP_VISIBILITYCHANGE: 'app_visibilitychange',
  HEARTBEAT: 'heartbeat',
  USER: 'user',
  ANONYMOUS_USER: 'amonymous_user',
  REGISTERED_USER: 'registered_user',
  DETAIL_PAGE: 'detail_page',
  FAVORITE: 'favorite',
  PAGE_IMPRESSION: 'page_impression',
  PAGE_IMPRESSION_EXIT: 'page_impression_exit',
  VIDEO_STARTED: 'video_started',
  VIDEO_VIEWED: 'video_viewed',
  VIDEO_VIEWED_REFERER: 'video_viewed_referer',
  VIDEO_VIEWED_TIME: 'video_viewed_time',
  VIDEO_VIEWED_PERCENTAGE: 'video_viewed_percentage',
  VIDEO_VIEWED_CATEGORY: 'video_viewed_category',
  STREAM_VIEWED: 'stream_viewed',
  STREAM_VIEWED_TIME: 'stream_viewed_time',
  STREAM_VIEWED_CATEGORY: 'stream_viewed_category',
  OUTGOING: 'outgoing',
  PROMOTIONS_APP: 'promotions_app',
  DEEP_LINK: 'deep_link',
  NETWORK: 'network',
  TUNE_CHANNEL: 'tune_channel',
  PLATFORM: 'platform',
  PERFORMANCE: 'performance',
  REMINDER: 'reminder',
  ERROR: 'error',
  IMAGE_VIEWED: 'image_viewed',
}

export const eventObject = {
  CONSENT: 'consent',
  PAGE: 'page',
  VIDEO: 'video',
  FAVORITE: 'favorite',
  REMINDER: 'reminder',
  TAB: 'tab',
  APP: 'app',
}

/**gtag analytics **/
export const eventAction = {
  OPENED: 'opened', //CONSENT
  CHANGED: 'changed', //CONSENT
  LOADED: 'loaded', //CONSENT

  VIEW: 'view', //PAGE

  START_CLICK: 'start-click', // VIDEO
  FULLSCREEN_CLICK: 'fullscreen-click', // VIDEO
  BACKGROUND_CLICK: 'background-click', // VIDEO
  FULLSCREEN_DEFAULT: 'fullscreen-default', // VIDEO
  LOADING: 'loading', // VIDEO
  START: 'start', // VIDEO
  MILESTONE_PERCENT: 'milestone-percent', // VIDEO  (vod)
  MILESTONE_10SEC: 'milestone-10sec', // VIDEO (STREAM)
  STOP: 'stop', // VIDEO
  PAUSE: 'pause', // VIDEO
  PLAY: 'play', // VIDEO
  ERROR: 'error', // VIDEO

  ADD: 'add', // FAVORITE
  SET: 'set', // REMINDER
  REMOVE: 'remove', // FAVORITE, REMINDER

  SELECT: 'select', // TAB

  /** USER */
  REGISTERED: 'registered_user',
  ANONYMOUS: 'anonymous_user',

  TUNING: 'tuning',
}
